import React, { useEffect, useState } from 'react';
import { EventImageType } from 'types/EventState';
import EventCoverImage from './EventCoverImage';

interface EventCoverImageWrapperProps {
  coverImage: EventImageType;
}

const EventCoverImageWrapper: React.FC<EventCoverImageWrapperProps> = ({
  coverImage: { original, small },
}) => {
  const [imageSource, setImageSource] = useState('');

  useEffect(() => {
    const img = new Image();
    img.src = original;
    img.onload = () => {
      setImageSource(original);
    };
  }, []);

  return <EventCoverImage image={imageSource ? original : small} />;
};

export default EventCoverImageWrapper;
